module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "maincontainer"
    }
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6 animated fadeInUp"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.bannerHome.title)
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.state.bannerHome.bannerTextTop))]), _c('h1', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v(_vm._s(_vm.state.bannerHome.bannerTextBottom))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "skew(10deg)"
    }
  }, [_c('a', {
    attrs: {
      "href": "#aboutus"
    }
  }, [_vm._v(_vm._s(_vm.state.bannerHome.btnText))])])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('about-us', {
    staticStyle: {
      "background-color": "white"
    }
  }), _vm._v(" "), _c('services', {
    staticStyle: {
      "background-color": "white"
    }
  }), _vm._v(" "), _c('map-page', {
    staticStyle: {
      "background-color": "white"
    }
  }), _vm._v(" "), _c('Clientes', {
    staticStyle: {
      "background-color": "white"
    }
  }), _vm._v(" "), _c('Contacto', {
    staticStyle: {
      "background-color": "white"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-6 animated fadeInUp"
  }, [_c('img', {
    staticClass: "img-container",
    attrs: {
      "src": require("../../assets/imgs/home_foto1.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0118b88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomePage.vue
// module id = 154
// module chunks = 0